module.exports = __webpack_public_path__ + "img/mb_header_bg2.05dd7b8.webp";